<template>
  <div class="container">
    <div class="left">
      <mine-user-icon v-if="userInfo" :data="userInfo"></mine-user-icon>
      <mine-tabs @change="changeIndex"></mine-tabs>
      <!--联系我们-->
      <div class="contactus">
        <div id="us">联系我们</div>
        <div id="phonelbl">客服电话</div>
        <div id="tel">400-602-1010</div>
        <div id="maillbl">客服邮箱</div>
        <div id="mail">cbnclub@yicai.com</div>
        <div id="wxbind">微信绑定提醒</div>
        <div><img src="@/components/BottomFooter/images/jg_icon.png" /></div>
      </div>
    </div>
    <div class="right">
      <!-- <mine-info :data="userInfo" v-if="selectedIndex == 5"></mine-info> -->
      <router-view></router-view>
    </div>
  </div>
</template>

<script>
import MineTabs from '@/components/BaseTabs/MineTabs.vue'
import MineUserIcon from '@/components/Mine/MineUserIcon.vue'

export default {
  name: 'Mine',
  components: { MineTabs, MineUserIcon },
  data() {
    return {
      selectedIndex: 0
    }
  },
  computed: {
    userInfo() {
      return this.$store.state.user.userInfo
    }
  },
  methods: {
    changeIndex(index) {
      this.selectedIndex = index
    }
  }
}
</script>

<style lang="scss" scoped>
.container {
  width: 1200px;
  margin: 10px auto;
  display: flex;
  margin-top: 30px;
}
.left {
  width: 332px;
  display: flex;
  flex-direction: column;
}
.contactus {
  border-top: 1px solid #ebebeb;
}
.contactus > div {
  padding-left: 20px;
}
#us {
  font-family: MicrosoftYaHei;
  font-size: 16px;
  font-weight: bold;
  font-stretch: normal;
  line-height: 40px;
  letter-spacing: 1px;
  color: #262626;
}
#phonelbl {
  font-family: MicrosoftYaHei;
  font-size: 14px;
  font-weight: normal;
  font-stretch: normal;
  line-height: 24px;
  letter-spacing: 1px;
  color: #262626;
}
#tel {
  font-family: MicrosoftYaHei;
  font-size: 14px;
  font-weight: normal;
  font-stretch: normal;
  line-height: 24px;
  letter-spacing: 1px;
  color: #858585;
}
#maillbl {
  font-family: MicrosoftYaHei;
  font-size: 14px;
  font-weight: normal;
  font-stretch: normal;
  line-height: 24px;
  letter-spacing: 1px;
  color: #262626;
}
#mail {
  font-family: MicrosoftYaHei;
  font-size: 14px;
  font-weight: normal;
  font-stretch: normal;
  line-height: 24px;
  letter-spacing: 1px;
  color: #858585;
}
#wxbind {
  font-family: MicrosoftYaHei;
  font-size: 14px;
  font-weight: normal;
  font-stretch: normal;
  line-height: 24px;
  letter-spacing: 1px;
  color: #262626;
}
</style>
